import { render } from "./Profile.view.vue?vue&type=template&id=f1fa5372"
import script from "./Profile.view.vue?vue&type=script&lang=js"
export * from "./Profile.view.vue?vue&type=script&lang=js"

import "./Profile.view.vue?vue&type=style&index=0&id=f1fa5372&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__